var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    props: {
        callbackFun: {
            type: Function,
            default: null,
        },
        keys: {
            type: String,
            default: 'fileGiftKey',
        },
        requestUrl: {
            type: String,
            default: '',
        },
        uploadUrl: {
            type: String,
            default: '',
        },
        pathName: {
            // 导入成功后要到哪个页面查看 对应页面路由
            type: String,
            default: '',
        },
        confirmSuccessRouterTxt: {
            // 结果页名称
            type: String,
            default: '列表页',
        },
        confirmBtnQueryText: {
            type: String,
            default: '查看',
        },
        successTxt: {
            type: String,
            dafault: '<p class="title">成功导入</p>',
        },
        messageType: {
            type: String,
            default: 'message',
        },
        buttonName: {
            type: String,
            default: '',
        },
        params: {
            type: Object,
            default: function () {
                return {};
            },
        },
        isUseSureBtn: {
            type: Boolean,
            default: false,
        },
    },
    computed: __assign({}, mapState('common', {
        percentage: 'percentage',
        showChangeFileBtn: 'showChangeFileBtn',
        changeBtnName: 'changeBtnName',
    })),
    data: function () {
        return {
            fileName: '',
            changeProcessBgColor: false,
            uploadStatus: '',
            fileKey: '',
            isImport: true,
            loadingMain: null,
        };
    },
    created: function () {
        this.initUpload();
    },
    methods: {
        initUpload: function () {
            this.$store.commit('common/update', {
                showChangeFileBtn: true,
                percentage: 0,
            });
        },
        beforeAvatarUpload: function (file) {
            var fileArr = file.name.split('.');
            var name = fileArr[fileArr.length - 1];
            var reg = /^xlsx|xls$/;
            if (!reg.test(name)) {
                this.$confirm('', '', {
                    message: '<p class="title">仅支持xlsx或xls格式文件</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '知道了',
                    showClose: false,
                    type: 'error',
                    showCancelButton: false,
                });
                return false;
            }
        },
        customRequest: function (_a) {
            var file = _a.file;
            this.file = file;
            this.fileName = file.name;
            this.uploadStatus = '上传完成';
            this.$store.commit('common/update', {
                showChangeFileBtn: false,
                percentage: 100,
                changeBtnName: '删除',
            });
            this.batchImport();
        },
        handleRemove: function () {
            this.$store.commit('common/update', {
                showChangeFileBtn: true,
            });
        },
        uploadError: function () {
            this.changeProcessBgColor = true;
            this.uploadStatus = '上传失败，请重试';
            this.$store.commit('common/update', {
                changeBtnName: '重新上传',
            });
        },
        canncelUploadFile: function () {
            var _this = this;
            if (this.changeBtnName === '重新上传') {
                this.$store.commit('common/update', {
                    percentage: 0,
                });
            }
            else if (this.changeBtnName === '删除') {
                this.$confirm('', '', {
                    message: '<p class="title">您确定要删除这个文件吗？</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                    showClose: false,
                })
                    .then(function () {
                    _this.$store.commit('common/update', {
                        showChangeFileBtn: true,
                    });
                    _this.$store.commit('common/update', {
                        changeBtnName: '取消',
                    });
                })
                    .catch(function () {
                    // this.percentage = 100
                });
            }
            else {
                this.$store.commit('common/update', {
                    percentage: 0,
                    showChangeFileBtn: true,
                    changeBtnName: '取消',
                });
            }
        },
        batchImport: function () {
            var _this = this;
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.$request({
                method: 'post',
                url: "/proxy/file/" + this.uploadUrl,
                data: __assign({ file: this.file }, this.params),
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (data[key] != null) {
                            formData.append(key, data[key]);
                        }
                    }
                    return formData;
                },
                loadingControl: 'hand',
            }).then(function (res) {
                if (!res) {
                    return _this.loadingMain.close();
                }
                if (res.errorCode !== 0) {
                    _this.isImport = true;
                    _this.$message.error(res.errorMsg);
                    _this.loadingMain.close();
                }
                else {
                    // 成功后
                    var key = res.data;
                    _this.fileKey = key;
                    _this.realGetImportPro(key);
                }
            });
        },
        getImportPro: function (key) {
            var _a;
            return this.$request({
                method: 'post',
                url: "/proxy/api/" + this.requestUrl,
                data: (_a = {},
                    _a[this.keys] = key,
                    _a),
                loadingControl: 'hand',
            });
        },
        realGetImportPro: function (key) {
            var _this = this;
            var times = 0;
            var pollingMain = function () {
                if (times > 40) {
                    _this.$message.error('网络超时，请稍后重试！');
                    return;
                }
                _this.getImportPro(key).then(function (res) {
                    if (!res || res.errorCode) {
                        _this.isImport = true;
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u6279\u91CF\u5BFC\u5165\u51FA\u9519\u4E86</p><p class=\"text\">" + res.errorMsg + "</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '知道了',
                            type: 'error',
                            showClose: false,
                        }).then(function () { });
                        return _this.loadingMain.close();
                    }
                    if (!res.data) {
                        setTimeout(function () {
                            times++;
                            pollingMain();
                        }, 500);
                        return;
                    }
                    _this.isImport = false;
                    var _a = _this, confirmSuccessRouterTxt = _a.confirmSuccessRouterTxt, confirmBtnQueryText = _a.confirmBtnQueryText, pathName = _a.pathName, messageType = _a.messageType, successTxt = _a.successTxt;
                    _this.loadingMain.close();
                    if (res.data === 'success') {
                        if (messageType === 'alert') {
                            _this.$confirm('', '', {
                                message: successTxt + "<p class=\"text\" style=\"margin-top:10px\">\u53EF\u524D\u5F80" + confirmSuccessRouterTxt + "\u67E5\u770B</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: confirmBtnQueryText,
                                cancelButtonText: '好的',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                _this.$router.push({ name: pathName });
                            })
                                .catch(function () { });
                            return;
                        }
                        if (messageType === 'message') {
                            _this.$message({
                                message: successTxt,
                                type: 'success',
                            });
                            if (!_this.isUseSureBtn) {
                                _this.$store.commit('common/update', {
                                    percentage: 0,
                                    showChangeFileBtn: true,
                                    changeBtnName: '取消',
                                });
                                return;
                            }
                            _this.$store.commit('common/update', {
                                showChangeFileBtn: false,
                            });
                        }
                    }
                    else {
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u5BFC\u5165\u5931\u8D25</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '下载信息',
                            cancelButtonText: '取消',
                            type: 'warning',
                            showClose: false,
                        })
                            .then(function () {
                            _this.$store.commit('common/update', {
                                showChangeFileBtn: true,
                            });
                            window.open(res.data);
                        })
                            .catch(function () {
                            _this.$store.commit('common/update', {
                                showChangeFileBtn: true,
                            });
                        });
                    }
                });
            };
            pollingMain();
        },
        callback: function () {
            this.callbackFun && this.callbackFun(this.fileKey);
        },
    },
});
